import { envConfig } from '../configuration/Configuration';
import { logger } from './LoggerHelper';
import axios from 'axios-jsonp-pro';

import config from '../config';

export interface EcsSettings {
    useMeetingsApi: boolean;
    useUnifiedView: boolean;
}

export interface EcsResponse {
    apiHost: string;
    cdnHost: string;
    version: string;
}

class EcsHelper {   
    public loadConfig(
        callback: ((settings: EcsResponse) => void)): void {
            if (config.ecs) {
                callback(config.ecs);
            }
            else {
                logger.Log("[EcsHelper]::loadConfig-> fetching the config");
                try
                {
                    axios.jsonp(envConfig.UrlEcs)
                    .then(function (response) {
                        logger.EcsLoadedSuccess();
                        let result:any = response;
                        let settingsToReturn: EcsResponse = {
                            apiHost: result.apiHost,
                            cdnHost: result.cdnHost,
                            version : result.version,
                        };
                        callback(settingsToReturn);
                    })
                    .catch(function (error) {
                        logger.EcsLoadingFailed({Error: error});
                        logger.Log('Error while fetching ecs', error);
                    });
                }
                catch (error)
                {
                    logger.EcsLoadingFailed({Error: error});
                    logger.Log('Error while fetching ecs', error);
                }
            }
    }
}

export const ecsHelper = new EcsHelper();